import { PRIVACY_NOTICE } from "@aventuria/client-core/legal";
import { LegalDocumentPage } from "../components/LegalDocumentView";

/**
 * Aviso de Privacidad Integral (LFPDPPP). Public: linked from registration, the personalized-trip
 * form, the loan flow and the Apartado consent. Legal's text lives in @aventuria/client-core/legal.
 */
export function PrivacyNoticePage() {
  return <LegalDocumentPage eyebrow="Aviso de Privacidad" document={PRIVACY_NOTICE} />;
}
